export default "__VITE_ASSET__Bhj_WtFo__"